import angular from 'angular';

export default function MemberTradeDetailCtrl($scope, $stateParams, TradesService, $uiViewScroll, $mdMedia, $state) {

  let subscription = TradesService.get($stateParams.id)
      .safeApply($scope, function (trade) {
        trade.new = false;
        $scope.trade = trade;
      }).subscribe();

  $scope.mdMedia = $mdMedia;

  $scope.goToMemberTrade = function (trade) {
    if (!trade || !trade._tradeno) {
      return;
    }
    var stateName = trade.BuyerID ? 'member.account.payables.trade' : 'member.account.receivables.trade';
    $state.go(stateName, {id: trade._tradeno});
  };

  $scope.$on("$destroy", function () {
    subscription.dispose();
  });

  $uiViewScroll(angular.element('#scroll-top'));
}
